<template>
  <el-dialog
    :visible.sync="showDialog"
    :width="modalWidth"
    top="15vh"
    :title="title"
    :modal-append-to-body="false"
    :before-close="handleClose"
    :close-on-click-modal="false"
    :destroy-on-close="true"
  >
    <div>
      <p
        class="text-fg-on-disabled font-normal text-sm break-normal mb-6 pr-3"
        test-id="transactionText"
      >
        Transfer funds from your {{ source }} Balance to your
        {{ destination }} Balance.
      </p>

      <el-form>
        <div
          class="flex flex-col"
          :class="{ 'flex-col-reverse': !transactionIsFundAccount }"
        >
          <el-form-item label="Holding Balance" prop="balance">
            <el-select class="w-full rounded-lg" v-model="funding.balance">
            </el-select>
          </el-form-item>
          <el-form-item label="Amount" prop="amount">
            <el-input
              type="number"
              prop="amount"
              name="amount"
              :placeholder="symbol"
              v-model="funding.amount"
            >
            </el-input>
          </el-form-item>
        </div>
        <el-form-item class="w-full pt-6">
          <el-button
            :disabled="isLoading"
            @click="handleClose"
            test-id="button"
            class="bg-primary text-white flex justify-center items-center lg:text-sm text-xs font-normal py-4 w-full rounded-lg cursor-pointer"
          >
            {{ isLoading ? 'Processing...' : btnText }}
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import breakpoints from '@/utils/breakpoints.js'
export default {
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    transactionType: {
      type: String,
      default: 'Fund Balance'
    },
    currencySymbol: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      isLoading: false,
      funding: {
        balance: '',
        amount: ''
      },
      breakpoints
    }
  },
  components: {},
  methods: {
    handleClose () {
      this.$emit('closeDialog')
    }
  },
  computed: {
    symbol () {
      return `${this.currencySymbol}0`
    },
    modalWidth () {
      return breakpoints.lgAndUp ? '33%' : breakpoints.mdAndUp ? '70%' : '90%'
    },
    transactionIsFundAccount () {
      return this.transactionType === 'Fund Balance'
    },
    title () {
      return this.transactionIsFundAccount ? 'Fund Balance' : 'Withdraw Funds'
    },
    source () {
      return this.transactionIsFundAccount ? 'Holding' : 'Card'
    },
    destination () {
      return this.transactionIsFundAccount ? 'Card' : 'Holding'
    },
    btnText () {
      return this.transactionIsFundAccount ? 'Add Funds' : 'Withdraw'
    }
  }
}
</script>

<style scoped>
>>> .el-dialog {
  border-radius: 16px;
  padding: 40px;
  background-color: white;
}
>>> .el-dialog__close::before,
.el-dialog__close::after {
  color: var(--foreground-default) !important;
}
>>> .el-dialog__header {
  display: flex;
  justify-content: center;
  padding-bottom: 1rem;
}
>>> .el-dialog__title {
  color: var(--foreground-default);
  font-weight: 600;
  font-size: 20px;
}
>>> .el-input__inner {
  background: var(--input-background);
  color: var(--input-text);
  height: 55px;
  border-radius: 8px;
}

>>> .el-form-item__label {
  color: var(--input-text);
  font-weight: 400;
}
>>> .el-form-item {
  margin-bottom: 16px;
}

>>> .el-dialog__body {
  padding: 0;
}
</style>
